<script>
  import Document from '~/components/Document.svelte';

  const privacy = `
Effective date: 09/15/2024  

# **Introduction**  
  
  Welcome to **Gram Jam**.

  Gram Jam (“us”, “we”, or “our”) operates <https://gramjam.app> and Gram Jam mobile application (hereinafter referred to as “**Service**”).

  Our Privacy Policy governs your visit to <https://gramjam.app> and Gram Jam mobile application, and explains how we collect, safeguard and disclose information that results from your use of our Service.

  We use your data to provide and improve Service. By using Service, you agree to the collection and use of information in accordance with this policy. Unless otherwise defined in this Privacy Policy, the terms used in this Privacy Policy have the same meanings as in our Terms and Conditions.

  Our Terms and Conditions (“**Terms**”) govern all use of our Service and together with the Privacy Policy constitutes your agreement with us (“**agreement**”).

# **Definitions**  

  **SERVICE** means the <https://gramjam.app> website and Gram Jam mobile application operated by Gram Jam.

  **PERSONAL DATA** means data about a living individual who can be identified from those data (or from those and other information either in our possession or likely to come into our possession).

  **USAGE DATA** is data collected automatically either generated by the use of Service or from Service infrastructure itself (for example, the duration of a page visit).

  **COOKIES** are small files stored on your device (computer or mobile device).

  **DATA CONTROLLER** means a natural or legal person who (either alone or jointly or in common with other persons) determines the purposes for which and the manner in which any personal data are, or are to be, processed. For the purpose of this Privacy Policy, we are a Data Controller of your data.

  **DATA PROCESSORS (OR SERVICE PROVIDERS)** means any natural or legal person who processes the data on behalf of the Data Controller. We may use the services of various Service Providers in order to process your data more effectively.

  **DATA SUBJECT** is any living individual who is the subject of Personal Data.

  **THE USER** is the individual using our Service. The User corresponds to the Data Subject, who is the subject of Personal Data.
  
# **Information Collection and Use**  
  We collect several different types of information for various purposes to provide and improve our Service to you.

# **Types of Data Collected**  
  ## **Personal Data**  

  While using our Service, we may ask you to provide us with certain personally identifiable information that can be used to contact or identify you (“**Personal Data**”). Personally identifiable information may include, but is not limited to:  
    - Email address
    - Address, State, Province, ZIP/Postal code, City
    - Cookies and Usage Data

  We may use your Personal Data to contact you with newsletters, marketing or promotional materials and other information that may be of interest to you. You may opt out of receiving any, or all, of these communications from us by following the unsubscribe link or by emailing at [support@gramjam.app](support@gramjam.app).

  ## **Usage Data**  

  We may also collect information that your browser sends whenever you visit our Service or when you access Service by or through a mobile device (“**Usage Data**”).

  This Usage Data may include information such as your computer's Internet Protocol address (e.g. IP address), browser type, browser version, the pages of our Service that you visit, the time and date of your visit, the time spent on those pages, unique device identifiers and other diagnostic data.

  When you access Service with a mobile device, this Usage Data may include information such as the type of mobile device you use, your mobile device unique ID, the IP address of your mobile device, your mobile operating system, the type of mobile Internet browser you use, unique device identifiers and other diagnostic data.

  ## **Tracking Cookies Data**

  We use cookies and similar tracking technologies to track the activity on our Service and we hold certain information.

  Cookies are files with a small amount of data which may include an anonymous unique identifier. Cookies are sent to your browser from a website and stored on your device. Other tracking technologies are also used such as beacons, tags and scripts to collect and track information and to improve and analyze our Service.

  You can instruct your browser to refuse all cookies or to indicate when a cookie is being sent. However, if you do not accept cookies, you may not be able to use some portions of our Service.

  Examples of Cookies we use:
  - **Session Cookies:** We use Session Cookies to operate our Service.
  - **Preference Cookies:** We use Preference Cookies to remember your preferences and various settings.
  - **Security Cookies:** We use Security Cookies for security purposes.

# **Use of Data**
  Gram Jam uses the collected data for various purposes:  
  - to provide and maintain our Service;
  - to notify you about changes to our Service;
  - to allow you to participate in interactive features of our Service when you choose to do so;
  - to provide customer support;
  - to gather analysis or valuable information so that we can improve our Service;
  - to monitor the usage of our Service;
  - to detect, prevent and address technical issues;
  - to fulfill any other purpose for which you provide it;
  - to carry out our obligations and enforce our rights arising from any contracts entered into between you and us, including for billing and collection;
  - to provide you with notices about your account and/or subscription, including expiration and renewal notices, email-instructions, etc.;
  - to provide you with news, special offers and general information about other goods, services and events which we offer that are similar to those that you have already purchased or enquired about unless you have opted not to receive such information;
  - in any other way we may describe when you provide the information;
  - for any other purpose with your consent.

# **Retention of Data**  

We will retain your Personal Data only for as long as is necessary for the purposes set out in this Privacy Policy. We will retain and use your Personal Data to the extent necessary to comply with our legal obligations (for example, if we are required to retain your data to comply with applicable laws), resolve disputes, and enforce our legal agreements and policies.

We will also retain Usage Data for internal analysis purposes. Usage Data is generally retained for a shorter period, except when this data is used to strengthen the security or to improve the functionality of our Service, or we are legally obligated to retain this data for longer time periods.

# **Transfer of Data**  

Your information, including Personal Data, may be transferred to - and maintained on - computers located outside of your state, province, country or other governmental jurisdiction where the data protection laws may differ from those of your jurisdiction.

If you are located outside United States and choose to provide information to us, please note that we transfer the data, including Personal Data, to United States and process it there.

Your consent to this Privacy Policy followed by your submission of such information represents your agreement to that transfer.

Gram Jam will take all the steps reasonably necessary to ensure that your data is treated securely and in accordance with this Privacy Policy and no transfer of your Personal Data will take place to an organisation or a country unless there are adequate controls in place including the security of your data and other personal information.

# **Disclosure of Data**  

We may disclose personal information that we collect, or you provide:
  - **Business Transaction.**
  If we or our subsidiaries are involved in a merger, acquisition or asset sale, your Personal Data may be transferred.

  - **Other cases. We may disclose your information also:**
    - with your consent in any other cases;

# **Security of Data**

The security of your data is important to us but remember that no method of transmission over the Internet or method of electronic storage is 100% secure. While we strive to use commercially acceptable means to protect your Personal Data, we cannot guarantee its absolute security.

# **Your Data Protection Rights Under General Data Protection Regulation (GDPR)**  

If you are a resident of the European Union (EU) and European Economic Area (EEA), you have certain data protection rights, covered by GDPR. – See more at <https://eur-lex.europa.eu/eli/reg/2016/679/oj>

We aim to take reasonable steps to allow you to correct, amend, delete, or limit the use of your Personal Data.

If you wish to be informed what Personal Data we hold about you and if you want it to be removed from our systems, please email us at [support@gramjam.app](support@gramjam.app).

In certain circumstances, you have the following data protection rights:  
  - the right to access, update or to delete the information we have on you;
  - the right of rectification. You have the right to have your information rectified if that information is inaccurate or incomplete;
  - the right to object. You have the right to object to our processing of your Personal Data;
  - the right of restriction. You have the right to request that we restrict the processing of your personal information;
  - the right to data portability. You have the right to be provided with a copy of your Personal Data in a structured, machine-readable and commonly used format;
  - the right to withdraw consent. You also have the right to withdraw your consent at any time where we rely on your consent to process your personal information;

Please note that we may ask you to verify your identity before responding to such requests. Please note, we may not able to provide Service without some necessary data.

You have the right to complain to a Data Protection Authority about our collection and use of your Personal Data. For more information, please contact your local data protection authority in the European Economic Area (EEA).

# **Your Data Protection Rights under the California Privacy Protection Act (CalOPPA)**  

CalOPPA is the first state law in the nation to require commercial websites and online services to post a privacy policy. The law’s reach stretches well beyond California to require a person or company in the United States (and conceivable the world) that operates websites collecting personally identifiable information from California consumers to post a conspicuous privacy policy on its website stating exactly the information being collected and those individuals with whom it is being shared, and to comply with this policy. – See more at: <https://consumercal.org/about-cfc/cfc-education-foundation/california-online-privacy-protection-act-caloppa-3/>

According to CalOPPA we agree to the following:  
  - users can visit our site anonymously;
  - our Privacy Policy link includes the word “Privacy”, and can easily be found on the page specified above on the home page of our website;
  - users will be notified of any privacy policy changes on our Privacy Policy Page;
  - users are able to change their personal information by emailing us at [support@gramjam.app](support@gramjam.app).

Our Policy on “Do Not Track” Signals:

We honor Do Not Track signals and do not track, plant cookies, or use advertising when a Do Not Track browser mechanism is in place. Do Not Track is a preference you can set in your web browser to inform websites that you do not want to be tracked.

You can enable or disable Do Not Track by visiting the Preferences or Settings page of your web browser.

# **Your Data Protection Rights under the California Consumer Privacy Act (CCPA)**

If you are a California resident, you are entitled to learn what data we collect about you, ask to delete your data and not to sell (share) it. To exercise your data protection rights, you can make certain requests and ask us:

  **What personal information we have about you**. If you make this request, we will return to you:

  - The categories of personal information we have collected about you.

  - The categories of sources from which we collect your personal information.

  - The business or commercial purpose for collecting or selling your personal information.

  - The categories of third parties with whom we share personal information.

  - The specific pieces of personal information we have collected about you.

  - A list of categories of personal information that we have sold, along with the category of any other company we sold it to. If we have not sold your personal information, we will inform you of that fact.

  - A list of categories of personal information that we have disclosed for a business purpose, along with the category of any other company we shared it with.

  Please note, you are entitled to ask us to provide you with this information up to two times in a rolling twelve-month period. When you make this request, the information provided may be limited to the personal information we collected about you in the previous 12 months.

  ## **To delete your personal information**.
  If you make this request, we will delete the personal information we hold about you as of the date of your request from our records and direct any service providers to do the same. In some cases, deletion may be accomplished through de-identification of the information. If you choose to delete your personal information, you may not be able to use certain functions that require your personal information to operate.

  ## **To stop selling your personal information**.
  We don't sell or rent your personal information to any third parties for any purpose. You are the only owner of your Personal Data and can request disclosure or deletion at any time.

Please note, if you ask us to delete or stop selling your data, it may impact your experience with us, and you may not be able to participate in certain programs or membership services which require the usage of your personal information to function. But in no circumstances, we will discriminate against you for exercising your rights.

To exercise your California data protection rights described above, please send your request(s) by one of the following means:

By email: [support@gramjam.app](support@gramjam.app)

Your data protection rights, described above, are covered by the CCPA, short for the California Consumer Privacy Act. To find out more, visit the official [California Legislative Information website](http://leginfo.legislature.ca.gov/faces/billTextClient.xhtml?bill_id=201720180AB375). The CCPA took effect on 01/01/2020.

# **Service Providers**

We may employ third party companies and individuals to facilitate our Service (“**Service Providers**”), provide Service on our behalf, perform Service-related services or assist us in analysing how our Service is used.

These third parties have access to your Personal Data only to perform these tasks on our behalf and are obligated not to disclose or use it for any other purpose.

# **Analytics**

We may use third-party Service Providers to monitor and analyze the use of our Service.

**Cloudflare analytics**

Cloudflare analytics is a web analytics service operated by Cloudflare Inc. Read the Privacy Policy here: <https://www.cloudflare.com/privacypolicy/>

# **Payments**

We may provide paid products and/or services within Service. In that case, we use third-party services for payment processing (e.g. payment processors).

We will not store or collect your payment card details. That information is provided directly to our third-party payment processors whose use of your personal information is governed by their Privacy Policy. These payment processors adhere to the standards set by PCI-DSS as managed by the PCI Security Standards Council, which is a joint effort of brands like Visa, Mastercard, American Express and Discover. PCI-DSS requirements help ensure the secure handling of payment information.

The payment processors we work with are:

## PayPal or Braintree:

Their Privacy Policy can be viewed at <https://www.paypal.com/webapps/mpp/ua/privacy-full>

## Apple Store In-App Payments:

Their Privacy Policy can be viewed at: <https://www.apple.com/legal/privacy/en-ww/> / <https://support.apple.com/en-us/HT203027>

## Google Play In-App Payments:

Their Privacy Policy can be viewed at: <https://policies.google.com/privacy?hl=en&gl=us> / <https://payments.google.com/payments/apis-secure/u/0/get_legal_document?ldo=0&ldt=privacynotice&ldl=en>

# **Links to Other Sites**

Our Service may contain links to other sites that are not operated by us. If you click a third party link, you will be directed to that third party's site. We strongly advise you to review the Privacy Policy of every site you visit.

We have no control over and assume no responsibility for the content, privacy policies or practices of any third party sites or services.

# **Children's Privacy**

Our Services are not intended for use by children under the age of 13 (“**Children**”).

We do not knowingly collect personally identifiable information from Children under 13. If you become aware that a Child has provided us with Personal Data, please contact us. If we become aware that we have collected Personal Data from Children without verification of parental consent, we take steps to remove that information from our servers.

# **Changes to This Privacy Policy**

We may update our Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page.

We will let you know via email and/or a prominent notice on our Service, prior to the change becoming effective and update “effective date” at the top of this Privacy Policy.

You are advised to review this Privacy Policy periodically for any changes. Changes to this Privacy Policy are effective when they are posted on this page.

# **Contact Us**

If you have any questions about this Privacy Policy, please contact us:

By email: [support@gramjam.app](support@gramjam.app).
  `;
</script>

<Document title="Privacy Policy" body={privacy} />
